<app-nav></app-nav>
  <section class="aboutUs">
    <div class="container">
      <div class="page_progress">

        <ul class="StepProgress">
    
          <li class="hand"> <strong>{{Acknowledged}}</strong>

            <span class="handover2">No Of Documents </span>
   
            <ul class="ll1" *ngFor="let item of getdocumentss">
              <li class="StepProgress-item1"><b>{{item.name}}</b>
                <span class="StepProgress-item1 count2"><b>{{item.count}}</b></span>
               
              </li>
 
            </ul>
                
</li>
        
        </ul>

        </div>
    </div>
  </section>

  <div id="spinner" [hidden]="!loading">
    <div class="spinnerfull">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
  </div>